import { render, staticRenderFns } from "./RelativeRelationTypeFilter.vue?vue&type=template&id=c1f6a12a&"
import script from "./RelativeRelationTypeFilter.vue?vue&type=script&lang=js&"
export * from "./RelativeRelationTypeFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports